<template>
  <div class="mb-32">
    <RevList :has-external-borders="false">
      <RevListItemInteractive
        data-qa="product-technical-specifications-button"
        @click="deployTechSpecModal"
      >
        <template #label>
          {{ i18n(translations.techSpec) }}
        </template>
        <template #suffix>
          <IconChevronRight />
        </template>
      </RevListItemInteractive>
      <RevListItemInteractive
        data-qa="product-warranty-button"
        @click="deployPerksModal"
      >
        <template #label>
          {{ i18n(translations.warranty) }}
        </template>
        <template #suffix>
          <IconChevronRight />
        </template>
      </RevListItemInteractive>
      <RevListItemInteractive
        v-if="instructions"
        data-qa="product-instructions-button"
        @click="deployInstructionsModal"
      >
        <template #label>
          {{ i18n(translations.instructions) }}
        </template>
        <template #suffix>
          <IconChevronRight />
        </template>
      </RevListItemInteractive>
      <RevListItemInteractive
        data-qa="product-frequently-asked-questions-button"
        @click="deployFaqModal"
      >
        <template #label>
          {{ i18n(translations.frequentlyAskedQuestions) }}
        </template>
        <template #suffix>
          <IconChevronRight />
        </template>
      </RevListItemInteractive>
    </RevList>
    <TechSpecModal :technical-specifications />
    <FaqModal :listing-id />
    <PerksModal :listing-id />
    <InstructionsModal v-if="instructions" :instructions :product-title />
  </div>
</template>

<script lang="ts" setup>
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { GetTechnicalSpecificationsResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/technical-specifications'
import TechSpecModal from '@backmarket/nuxt-layer-product-modals/TechSpecModal.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './AdditionalInfo.translations'
import FaqModal from './components/FaqModal/FaqModal.vue'
import InstructionsModal from './components/InstructionsModal/InstructionsModal.vue'
import PerksModal from './components/PerksModal/PerksModal.vue'

defineProps<{
  listingId: number
  productTitle: GetProductResponse['titles']['raw']
  technicalSpecifications: GetTechnicalSpecificationsResponse
  instructions: GetProductResponse['instructions']
}>()

const i18n = useI18n()

function deployTechSpecModal() {
  openModal(MODAL_NAMES.TECH_SPECS)
}

function deployFaqModal() {
  openModal(MODAL_NAMES.FAQ)
}

function deployPerksModal() {
  openModal(MODAL_NAMES.PERKS)
}

function deployInstructionsModal() {
  openModal(MODAL_NAMES.INSTRUCTIONS)
}
</script>
